module.exports = __webpack_public_path__ + "img/logo2zz.baf13f6f.png";